// extracted by mini-css-extract-plugin
export default {"root":"h6vwa__root","button":"KOMBP__button YB6BY__iconButton vb-icon"};